// @codekit-prepend "jquery.fitvids.js"
// @codekit-prepend "jquery.sidr.min.js"
require('./jquery.fitvids.js');
require('./jquery.sidr.min.js');

jQuery(function($) {
  // FitVids
  $('.entry-content').fitVids();

  // Mobile Menu
  $('.mobile-menu-toggle').sidr({
    name: 'sidr-mobile-menu',
    side: 'right',
    renaming: false,
    displace: false,
  });
  $('.menu-item-has-children > a').click(function(e) {
    $(this)
      .parent()
      .toggleClass('submenu-active');
    e.preventDefault();
  });
  $('.sidr-menu-close').click(function(e) {
    $.sidr('close', 'sidr-mobile-menu');
    e.preventDefault();
  });
  $(document).on('mouseup touchend', function(e) {
    var container = $('#sidr-mobile-menu');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $.sidr('close', 'sidr-mobile-menu');
    }
  });

  // Smooth scrolling anchor links
  function pmlorg_scroll(hash) {
    var target = $(hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      var top_offset = 0;
      if ($('.site-header').css('position') == 'fixed') {
        top_offset = $('.site-header').height();
      }
      if ($('body').hasClass('admin-bar')) {
        top_offset = top_offset + $('#wpadminbar').height();
      }
      $('html,body').animate(
        {
          scrollTop: target.offset().top - top_offset,
        },
        1000
      );
      return false;
    }
  }
  // -- Smooth scroll on pageload
  if (window.location.hash) {
    pmlorg_scroll(window.location.hash);
  }
  // -- Smooth scroll on click
  $('a[href*="#"]:not([href="#"]):not(.no-scroll)').click(function() {
    if (
      location.pathname.replace(/^\//, '') ==
        this.pathname.replace(/^\//, '') ||
      location.hostname == this.hostname
    ) {
      pmlorg_scroll(this.hash);
    }
  });

  // JS fix to support full width when a sidebar is making this positioning challenging
  // note: do all the coupled styling here so if they have JS disabled we don't adjust the default behavior
  function alignfull_sidebar_fix() {
    var shallowCopy = $.extend({}, $('.alignfull-fix-spacer'));
    shallowCopy.each(function(index) {
      $(this).remove();
    });

    $('.alignfull').each(function(index) {
      let parent = this.parentNode;
      let height = this.getBoundingClientRect().height;

      let el = document.createElement('div');
      el.classList.add('alignfull-fix-spacer');
      el.style.height = `${height}px`;

      parent.insertBefore(el, this);

      this.style.left = 0;
      this.style.margin = 0;
      this.style.maxWidth = 'none';
      this.style.position = 'absolute';
      this.style.right = '222px';
      this.style.width = 'auto';

      if ($(window).width() < 768) {
        this.style.right = 0;
      }

      let top = el.getBoundingClientRect().top;
      this.style.top = `${top}px`;
    });
  }

  // alignfull_sidebar_fix();
  // window.setTimeout(alignfull_sidebar_fix, 200); // gotta wait and reevaluate for page loads that are below water
  // window.addEventListener('resize', alignfull_sidebar_fix);
});
